import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialogConfig, MatDialog } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { OrderService } from '../_ecomservices/order.service';
import { LoadingService } from '../../_services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/_services/notification.service';
import { DeliveryVehicleService } from '../_ecomservices/delivery-vehicle.service';
import { OrderEditComponent } from '../order-edit/order-edit.component';

@Component({
  selector: 'app-order-process',
  templateUrl: './order-process.component.html',
  styleUrls: ['./order-process.component.css']
})
export class OrderProcessComponent implements OnInit {

  displayedColumns: string[] = ['select',  'OrderDate', 'Qty', 'Customer',  
    'OrderStatus'];
   
   orderList: any = [];
   slNo:number = 0;
   totalPacket:number = 0;
   orderSelection = new SelectionModel<any>(true, []);  
   deliveryVehicleList= [];
   selecteddeliveryVehicle:number = 0;
   orderStatusList:number = 0;
   selectedOrderStatus:number = 0;
   
   dataSource: MatTableDataSource<any>;
   searchKey: string;
 
   order_status_form = new FormGroup({
     id : new FormControl(null),
     order_status : new FormControl('', [Validators.required]),
     shipping_status : new FormControl(''),
     created_at : new FormControl(''),
   });
 
   constructor(
   private titleService: Title,
   private dialog: MatDialog,
   public orderService: OrderService,
   private loading : LoadingService,
   private deliveryVehicleService:DeliveryVehicleService,
   public datePipe: DatePipe,
   private notificationService: NotificationService,
   private route: ActivatedRoute,) { }
 
 
   ngOnInit() {
     this.titleService.setTitle('Order List');
     this.onLoadOrders();
     this.onLoadVehicles();
   }
 
   onLoadOrders() {
    var result = this.orderService.get_new_orders().subscribe(data=> {
    this.orderList = data['orderList'];
      this.dataSource = new MatTableDataSource<any>(this.orderList);       
      this.orderStatusList = data['next_status_list'];
      this.loading.spin$.next(false);
    });
   }
 
   onLoadVehicles() {
     //console.log('ok');
     var result = this.deliveryVehicleService.delivery_active_vehicles().subscribe(data=> {
       this.deliveryVehicleList = data['vehicles'];
     });
   }
 
   applyFilter() {
     this.dataSource.filter = this.searchKey.trim().toLocaleLowerCase();
   }
 
   onSearchClear() {
     this.searchKey = "";
     this.applyFilter();
   }
 
   onChangeOrderSelection($event, row){
     $event ? this.orderSelection.toggle(row) : null;
     if($event.checked){
       this.slNo++;
       this.totalPacket = this.totalPacket + row.total_packet;
       row.sl_no = this.slNo;
     }
     else{
       this.totalPacket = this.totalPacket - row.total_packet;
       this.slNo--;
       row.sl_no = '';
     }
     this.totalPacket = 0;
     this.orderSelection.selected.forEach(element => {
       this.totalPacket += element.total_packet;
     });
     console.log(this.totalPacket);
   }
 
   onChangeVehicle(){
    //  console.log(this.selecteddeliveryVehicle);
     let vehDetails = this.deliveryVehicleList.find(x=> x.id === this.selecteddeliveryVehicle);
     if(vehDetails){
      console.log(vehDetails);
     }
   }

  onEditOrder(order_id) 
  {
    const matDialogConfig = new MatDialogConfig();
    matDialogConfig.disableClose = true;
    matDialogConfig.autoFocus = true;
    matDialogConfig.width = "99%";
    matDialogConfig.position = { top: '0px' };
    matDialogConfig.data = { order_id: order_id, isEditItemOnly: true };
    this.dialog.open(OrderEditComponent, matDialogConfig).afterClosed().subscribe(res=>{
      // console.log(res);
      this.onLoadOrders();
    });
  }
 
  onAssignedForDelivery(){
    if (this.orderSelection.selected.length > 0){
      if(this.selecteddeliveryVehicle <= 0){
        this.notificationService.warn('Please selecte delivery vehicle');
      }
      else if(this.selectedOrderStatus <= 0){
        this.notificationService.warn('Please selecte order status');
      }
      else
      {
        this.loading.spin$.next(true);
        this.orderService.order_assigned_for_delivery(this.orderSelection.selected, this.selecteddeliveryVehicle, this.selectedOrderStatus).subscribe(data=>{          
          if (data['status']) 
          {
            this.orderSelection.clear();
            this.slNo = 0;
            this.totalPacket = 0;
            this.selecteddeliveryVehicle = 0;
            this.selectedOrderStatus = 0;
            this.onLoadOrders();
            this.notificationService.success(data['message']);
            this.loading.spin$.next(false);
          } 
          else 
          {
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }
    }
    else{
      this.notificationService.warn('Please selecte order for asign to delivery');
    }
  }
 
 
 }
 